import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: grid;
  padding-top: 2rem;
  grid-template-columns: 1fr 1fr;

  ${({ theme }) => theme.mediaQueries.laptop} {
    grid-template-columns: repeat(4, 1fr);
  }
  ${({ theme }) => theme.mediaQueries.desktop} {
    padding: 0;
  }
`;

export const Article = styled.article`
  position: relative;
  grid-column: 1 / 3;
  padding: 0.5rem 0;
  background: ${({ theme }) => theme.colors.white};

  ${({ theme }) => theme.mediaQueries.laptop} {
    grid-column: 2 / -1;
    padding: 0.5rem 0;
    margin: 2rem 1.5rem;
  }
`

